/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from 'react';
import {Col, FormCheck, FormControl, Row} from 'react-bootstrap';

import {service as SpeciesInvasivityService} from "../../../../../Services/SpeciesInvasivityService";
import {service as SpeciesNativityService} from "../../../../../Services/SpeciesNativityService";
import {service as SpeciesTypeService} from "../../../../../Services/SpeciesTypeService";
import {usePrimeCache} from "../../../../../Hooks/ServiceHooks";
import {useUpdateTableFilters} from "../../../../../Hooks/TableHooks";
import {LastModifiedSpeciesLabel} from "./LastModifiedSpeciesLabel";

export const SpeciesTableFilter = (props) => {
    const {
        Data,
        UpdateFilters: updateFilters = null,
        OnEditClick,
        filterValues,
        setFilterValue
    } = props;

    usePrimeCache([
        SpeciesTypeService,
        SpeciesNativityService,
        SpeciesInvasivityService,
    ]);
    const types = SpeciesTypeService.CachedValues()?.result ?? [];
    const {
        showAll = false,
        speciesTypeId = null,
        textFilter = '',
    } = filterValues;

    const textFilterUppercase = textFilter?.toUpperCase?.();
    
    const filters = [
        {
            code: 'showAll',
            isSet: !showAll,
            // logic: x => x?.SpeciesListSpecies?.speciesListSpeciesId != null && x?.SpeciesListSpecies?.deleted == null,
            logic: x => x?.SpeciesListSpecies?.speciesListSpeciesId != null && x?.SpeciesListSpecies?.deleted == null
        },
        {
            code: 'textFilter',
            isSet: textFilterUppercase !== "",
            logic:  x => x?.commonName?.toUpperCase?.().includes(textFilterUppercase) ||
                    x?.latinName?.toUpperCase?.().includes(textFilterUppercase) ||
                    (x?.SpeciesListSpecies?.alternativeCommonName ?? x?.commonName)?.toUpperCase().includes(textFilterUppercase) ||
                    (x?.SpeciesListSpecies?.alternativeLatinName  ?? x?.latinName)?.toUpperCase().includes(textFilterUppercase) ||
                    SpeciesTypeService.CachedTitleById(x?.SpeciesListSpecies?.speciesTypeId ?? x?.speciesTypeId)?.toUpperCase?.().includes(textFilterUppercase) ||
                    SpeciesNativityService.CachedTitleById(x?.SpeciesListSpecies?.speciesNativityId ?? x?.speciesNativityId)?.toUpperCase?.().includes(textFilterUppercase) ||
                    SpeciesInvasivityService.CachedTitleById(x?.SpeciesListSpecies?.speciesInvasivityId ?? x?.speciesInvasivityId)?.toUpperCase?.().includes(textFilterUppercase)
        },
        {
            code: "speciesTypeId",
            isSet: !!speciesTypeId,
            logic: x => Number(x?.SpeciesListSpecies?.speciesTypeId ?? x?.speciesTypeId) === Number(speciesTypeId)
        }
    ];

    useUpdateTableFilters(filters, updateFilters, [showAll, textFilter, speciesTypeId]);

    return <Fragment>
        <Col md={4} sm={12} xs={12}>
            <LastModifiedSpeciesLabel data={Data} onDateClick={(id) => OnEditClick(id)} />
        </Col>
        <Col md={8} sm={12} xs={12}>
            <Row className="justify-content-end">
                <Col xs={4} className="d-flex align-items-center justify-content-end">
                    <FormCheck
                        id="view-all-species"
                        type="checkbox"
                        label="View All Species"
                        checked={showAll}
                        onChange={event => void setFilterValue('showAll', !showAll)}
                    />
                </Col>
                <Col xs={4} className="d-flex align-items-center">
                    <FormControl
                        as="select"
                        type="text"
                        value={speciesTypeId ?? ""}
                        placeholder="Growth Form"
                        onChange={event => setFilterValue('speciesTypeId', event.target.value)}
                    >
                        <option value={""}>Growth Form</option>
                        {
                            types.map(x =>
                                <option key={x.speciesTypeId} value={x.speciesTypeId}>
                                    {x.name}
                                </option>
                            )
                        }
                    </FormControl>
                </Col>
                <Col xs={4} className="d-flex align-items-center">
                    <FormControl
                        type="text"
                        value={textFilter || ""}
                        placeholder="Search Names"
                        onChange={event => setFilterValue('textFilter', event.target.value)}
                    />
                </Col>
            </Row>
            <Row/>
        </Col>
    </Fragment>;
};
